/**
 * Coarse launch toggles for features that exist in code but aren't live yet.
 * Nav tabs (desktop + mobile), dashboard quick actions, the store's Packs tab,
 * and the /collection and /packs page guards all read from here.
 *
 * Mirrors apps/nextjs/src/config/features.ts — keep the two in step. Vite
 * inlines import.meta.env at build time and each target builds its own bundle,
 * so staging can run a feature hot while production stays dark from the same
 * commit.
 *
 * OFF is the default and the fallback: only the exact string 'true' enables a
 * feature, so an unset, empty or misspelled var leaves it gated.
 *
 * Set by .github/workflows/upload-jest-client.yml from the resolved target
 * (staging: true, production: false).
 */

/** Card packs + collection (card-league economy surfaces). */
export const PACKS_COLLECTION_LIVE =
  (import.meta.env.VITE_PACKS_LIVE as string | undefined) === 'true';
